module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ed-Gd.1ec235a0.png";